import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=bd830d76&scoped=true"
import script from "./FooterBlock.vue?vue&type=script&lang=js"
export * from "./FooterBlock.vue?vue&type=script&lang=js"
import style0 from "./FooterBlock.vue?vue&type=style&index=0&id=bd830d76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd830d76",
  null
  
)

export default component.exports